<template>
  <v-app>
    <toolbar/>
    <v-main>
      <router-view/>
    </v-main>
    <div style="padding: 20px 0;">
      <img src="@/assets/icon.png" width="20" style="margin: 0 auto;display: block;"/>
      <div style="text-align: center;font-size: 8px;">Secure By</div>
    </div>
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
* {
  font-family: "Inter", sans-serif;
}
</style>

<script>
import toolbar from './components/toolbar.vue'
export default {
  name: 'App',

  data: () => ({
    //
  }),
  components: {
    toolbar
    }
};
</script>
